(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["affirm-financing-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('affirm-popup')) {

    class AffirmPopup extends HTMLElement {
      connectedCallback() {
        this.inner = this.querySelector('.popup-inner');
        this.overlay = this.querySelector('.popup-overlay');
        this.closeBtn = this.querySelector('.popup-close');
        this.duration = 400;
        this._controller = new AbortController();
        const { signal } = this._controller;

        document.addEventListener('click', (e) => {
          if (e.target.closest && e.target.closest('.open-affirm-popup')) {
            e.preventDefault();
            this.open();
          }
        }, { signal });

        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', (e) => { e.preventDefault(); this.close(); }, { signal });
        }
        if (this.overlay) {
          this.overlay.addEventListener('click', (e) => { if (e.target === this.overlay) this.close(); }, { signal });
        }
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.classList.contains('popup-visible')) this.close();
        }, { signal });
      }

      disconnectedCallback() {
        if (this._controller) this._controller.abort();
        if (this._timer) clearTimeout(this._timer);
      }

      open() {
        this._lastFocused = document.activeElement;
        this.style.display = 'flex';
        if (this._timer) clearTimeout(this._timer);
        requestAnimationFrame(() => {
          this.classList.add('popup-visible');
          this.setAttribute('role', 'dialog');
          this.setAttribute('aria-modal', 'true');
          if (this.inner) this.inner.focus({ preventScroll: true });
        });
      }

      close() {
        this.classList.remove('popup-visible');
        this.removeAttribute('aria-modal');
        this._timer = setTimeout(() => {
          this.style.display = 'none';
          this.removeAttribute('role');
        }, this.duration);
        if (this._lastFocused && this._lastFocused.focus) this._lastFocused.focus({ preventScroll: true });
      }
    }

    customElements.define('affirm-popup', AffirmPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["silo-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('silo-popup')) {
    // Thin custom element: exposes an open()/close() API on the <silo-popup> node
    // and delegates to the shared popup engine (window.siloPopupManager), which
    // still drives steps, the form, and all the other triggers.
    class SiloPopup extends HTMLElement {
      // The header photo is a CSS background (--popup-desktop-header / --popup-mobile-header), and browsers only fetch a
      // background when its element is first shown — the moment the popup opens. On slow phone connections the popup
      // slid up with a blank header and the photo arrived seconds later. Warm the photo for this viewport once the page
      // is idle (~29 KB phone / 51 KB desktop, never competing with the first paint), so it is cached before any trigger.
      connectedCallback() {
        if (this._warmT) return;
        const warm = () => {
          const phone = window.matchMedia('(max-width: 768px)').matches; // the popup CSS breakpoint
          const el = this.querySelector(phone ? '#header-mobile' : '#silo-popup-inner');
          const raw = el && getComputedStyle(el).getPropertyValue(phone ? '--popup-mobile-header' : '--popup-desktop-header');
          const m = raw && raw.match(/url\(\s*["']?([^"')]+)["']?\s*\)/);
          if (m) { const img = new Image(); img.decoding = 'async'; img.src = m[1]; }
        };
        const idle = () => ('requestIdleCallback' in window ? requestIdleCallback(warm, { timeout: 4000 }) : warm());
        this._warmT = setTimeout(idle, 2500);
      }
      disconnectedCallback() { clearTimeout(this._warmT); this._warmT = 0; }
      open() {
        if (window.siloPopupManager) window.siloPopupManager.open('element_api');
      }
      close() {
        if (window.siloPopupManager) window.siloPopupManager.close();
      }
    }
    customElements.define('silo-popup', SiloPopup);
  }
  } catch(e) { console.error(e); }
})();

})();
